// action
import {
    DELETE_DOCTOR,
    DELETE_DOCTOR_FAIL,
    DELETE_DOCTOR_SUCCESS,
    DELETE_DOCTOR_RESET
} from '../action/deleteDoctorAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_DOCTOR:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_DOCTOR_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_DOCTOR_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case DELETE_DOCTOR_RESET:
            return initialState
        default:
            return state
    }
}